import { render, staticRenderFns } from "./RemarkCancel.vue?vue&type=template&id=afad8f44&scoped=true&"
import script from "./RemarkCancel.vue?vue&type=script&lang=js&"
export * from "./RemarkCancel.vue?vue&type=script&lang=js&"
import style0 from "./RemarkCancel.vue?vue&type=style&index=0&id=afad8f44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afad8f44",
  null
  
)

export default component.exports